import React, { useState } from 'react';
import './homepage.css';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import SocialProofBar from './components/SocialProofBar';
import FeaturesSection from './components/FeaturesSection';
import MethodsLibrarySection from './components/methods/MethodsLibrarySection';
import PlatformSection from './components/PlatformSection';
import IntegrationsSection from './components/IntegrationsSection';
import PricingSection from './components/PricingSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import ScrollIndicator from './components/ScrollIndicator';
import DemoTour from '../../components/DemoTour/DemoTour';
import ChatWidget from '../../components/ChatWidget';

const HomePage: React.FC = () => {
  const [demoOpen, setDemoOpen] = useState(false);

  return (
    <div className="homepage">
      <Navbar />
      <ScrollIndicator />
      <main>
        <HeroSection onDemoClick={() => setDemoOpen(true)} />
        <SocialProofBar />
        {/* SocialProof → Features */}
        <div className="hp-wave-divider" style={{ backgroundColor: '#0f172a' }}>
          <svg viewBox="0 0 1440 100" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0,100 C240,20 480,50 720,35 C960,20 1200,70 1440,10 L1440,100 L0,100 Z" style={{ fill: 'var(--hp-beige)' }}/>
          </svg>
        </div>
        <FeaturesSection />
        {/* Features → MethodsLibrary */}
        <div className="hp-wave-divider" style={{ backgroundColor: 'var(--hp-beige)' }}>
          <svg viewBox="0 0 1440 100" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0,100 C180,10 540,40 720,30 C900,20 1260,60 1440,5 L1440,100 L0,100 Z" style={{ fill: '#0f172a' }}/>
          </svg>
        </div>
        <MethodsLibrarySection />
        <PlatformSection />
        {/* Platform → Integrations */}
        <div className="hp-wave-divider" style={{ backgroundColor: '#0f172a' }}>
          <svg viewBox="0 0 1440 100" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0,100 C360,15 720,60 1080,30 C1260,15 1380,50 1440,25 L1440,100 L0,100 Z" style={{ fill: 'var(--hp-beige)' }}/>
          </svg>
        </div>
        <IntegrationsSection />
        {/* Integrations → Pricing */}
        <div className="hp-wave-divider" style={{ backgroundColor: 'var(--hp-beige)' }}>
          <svg viewBox="0 0 1440 100" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0,100 C480,15 960,55 1440,10 L1440,100 L0,100 Z" style={{ fill: '#0f172a' }}/>
          </svg>
        </div>
        <PricingSection />
        <TestimonialsSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
      {demoOpen && <DemoTour onClose={() => setDemoOpen(false)} />}
      <ChatWidget />
    </div>
  );
};

export default HomePage;
